export default __webpack_public_path__ + "static/media/a4.d7a33fa6.png";